import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { FiX } from 'react-icons/fi'
import IconRail from './icon-rail'

function MobileMenu({ open, onClose, entries, activeKey }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as='div' className='tw-relative tw-z-[90] md:tw-hidden' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='tw-transition-opacity tw-duration-200'
          enterFrom='tw-opacity-0'
          enterTo='tw-opacity-100'
          leave='tw-transition-opacity tw-duration-150'
          leaveFrom='tw-opacity-100'
          leaveTo='tw-opacity-0'
        >
          <div aria-hidden='true' className='tw-fixed tw-inset-0 tw-bg-ink/40' />
        </Transition.Child>

        <div className='tw-fixed tw-inset-y-0 tw-left-0 tw-flex tw-max-w-full'>
          <Transition.Child
            as={Fragment}
            enter='tw-transform tw-transition tw-duration-200 tw-ease-out'
            enterFrom='-tw-translate-x-full'
            enterTo='tw-translate-x-0'
            leave='tw-transform tw-transition tw-duration-150 tw-ease-in'
            leaveFrom='tw-translate-x-0'
            leaveTo='-tw-translate-x-full'
          >
            <Dialog.Panel className='tw-relative tw-h-full tw-w-[280px] tw-max-w-[85vw] tw-shadow-pop'>
              <Dialog.Title className='tw-sr-only'>Navigation</Dialog.Title>
              <button
                type='button'
                onClick={onClose}
                aria-label='Close navigation'
                className='tw-absolute tw-right-3 tw-top-4 tw-z-10 tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-[10px] tw-text-inkSoft hover:tw-bg-sand focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'
              >
                <FiX aria-hidden='true' className='tw-h-5 tw-w-5' />
              </button>
              <IconRail entries={entries} activeKey={activeKey} variant='panel' onNavigate={onClose} />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default MobileMenu
